import { render, staticRenderFns } from "./EventsOverview.vue?vue&type=template&id=70b22a1e"
import script from "./EventsOverview.vue?vue&type=script&lang=js"
export * from "./EventsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports